import React from 'react'
import { useParams } from 'react-router-dom'
import Ret00cDetail from './Ret00cDetail'

function Show(): JSX.Element {
  const { id = '' } = useParams<{ id: string }>()

  return <Ret00cDetail id={id} mode='page' />
}

export default Show
